import paymentMethods from "utils/static/paymentMethods";

import {
    add as _add,
    update as _update,
    deleteAll as _deleteAll,
    getAsync as _getAsync,
    getList as _getList,
} from "../api";
import { dateToString } from "utils/dateUtils";

let BASE_URL = null;
let BASE_RECEIPTS_URL = null;
const DEFAULT_LIST_DATA = {
    filter: {},
    orderBy: "date",
    orderDirection: "desc",
    pageNumber: 0,
    pageSize: 15,
};

export function initDB(dbName) {
    BASE_URL = `/modules/${dbName}/accounting`;
    BASE_RECEIPTS_URL = `/modules/${dbName}/receipts`;
}

function normalizeAccountingData(data) {
    const { date: dateInMillis, paymentMethod } = data;

    const date = new Date(dateInMillis);

    return {
        ...data,
        date,
        dateString: dateToString(date, false),
        paymentMethodString: paymentMethod ? paymentMethods.find((x) => x.value === paymentMethod).label : "",
    };
}

function normalizeData(data) {
    return data.map((d) => normalizeAccountingData(d));
}

export async function getAllAsync(personalInfoId) {
    return _getAsync({ url: `${BASE_URL}/filecase/${personalInfoId}`, normalizer: normalizeData });
}

export function getList({ personalInfoId, onSuccess, onInfo, onError, data = DEFAULT_LIST_DATA }) {
    _getList({
        url: `${BASE_URL}/filecase/${personalInfoId}`,
        data,
        onSuccess,
        onInfo,
        onError,
        normalizer: normalizeData,
    });
}

export async function getReceiptsAsync(personalInfoId) {
    return _getAsync({ url: `${BASE_RECEIPTS_URL}/filecase/${personalInfoId}` });
}

export async function getReceiptsByDateRangeAsync(initialDate, finalDate) {
    return _getAsync({ url: `${BASE_RECEIPTS_URL}/range`, data: { initialDate, finalDate } });
}

export async function getReceiptsByDateRangeAnnulmentAsync(initialDate, finalDate) {
    return _getAsync({ url: `${BASE_RECEIPTS_URL}/range:annulment`, data: { initialDate, finalDate } });
}

export async function getBalanceAsync(personalInfoId) {
    return _getAsync({ url: `${BASE_URL}/filecase/${personalInfoId}/balance` });
}

export async function getAccountingReceiptsAsync(accountingId) {
    return _getAsync({
        url: `${BASE_RECEIPTS_URL}/accounting/${accountingId}`,
    });
}

export async function getAccountingInvoiceAsync(accountingId) {
    return _getAsync({
        url: `${BASE_URL}/${accountingId}/invoice`,
    });
}

export function add({ payload, onSuccess, onError }) {
    _add({ url: `${BASE_URL}/create/return-entity`, data: payload, onSuccess, onError });
}

export function update({ payload, onSuccess, onError }) {
    _update({ url: `${BASE_URL}/${payload.id}`, data: payload, onSuccess, onError });
}

export function deleteAll({ ids, onSuccess, onError }) {
    _deleteAll({ url: BASE_URL, data: { ids }, onSuccess, onError });
}
